import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, GoogleAuthProvider } from "firebase/auth";


const firebaseConfig = {
  apiKey: "AIzaSyD3qQ9--0dNWGXAQlY_HapP5HcJX6ZJcn8",
  authDomain: "mygainlog.firebaseapp.com",
  projectId: "mygainlog",
  storageBucket: "mygainlog.firebasestorage.app",
  messagingSenderId: "1084109096048",
  appId: "1:1084109096048:web:561d8f177b9a208398e0b5",
  measurementId: "G-034168DQH1"
};


const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();